module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-5c97293f.png";